import { inject, PLATFORM_ID } from '@angular/core';
import { CanActivateFn, Router, UrlTree } from '@angular/router';
import { isPlatformBrowser } from '@angular/common';
import { map, Observable } from 'rxjs';
import { StoresService } from '../services/stores.service';
import { UserService } from '../services/user.service';

export const showClientsGuard: CanActivateFn = (_route, state): Observable<boolean | UrlTree> | boolean | UrlTree => {
    const storesService = inject(StoresService);
    const userService = inject(UserService);
    const router = inject(Router);
    const platformId = inject(PLATFORM_ID);
    const slug = state?.root?.firstChild?.params?.slug;

    let role = userService.currentUser.value?.role;
    if (!role && isPlatformBrowser(platformId)) {
        const storedUser = localStorage?.getItem('currentUser');
        if (storedUser) {
            role = JSON.parse(storedUser)?.role;
        }
    }

    return storesService.getActiveStore(slug).pipe(
        map((store) => {
            if (userService.canShowClientsPage(store, role)) {
                return true;
            }

            router.navigate(['/']);
            return false;
        }),
    );
};
